import { Navigate, Route } from 'react-router-dom';
import { SignUpPage } from '../pages/Auth/SignUpPage';
import { LoginPage } from '../pages/Auth/LoginPage';
import { ROUTES } from '../constants/FrontendPathConstants';

export const publicRoutes = (
  <>
    {/* Only include specific auth routes, not the home route */}
    <Route path={ROUTES.SIGNUP} element={<SignUpPage />} />
    <Route path={ROUTES.LOGIN} element={<LoginPage />} />
  </>
);
